// All of these functions call on requestIdleCallback execution
// Only put functions here that are not critical to the immediate customer experience
// but can be run in the background
const onIdleLoad = () => {}

export default onIdleLoad
